import { render, staticRenderFns } from "./Checkout.vue?vue&type=template&id=6c987631&scoped=true&"
import script from "./Checkout.vue?vue&type=script&lang=js&"
export * from "./Checkout.vue?vue&type=script&lang=js&"
import style0 from "./Checkout.vue?vue&type=style&index=0&id=6c987631&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c987631",
  null
  
)

export default component.exports